import { allRequiredChecked } from "@fiket/booth-schema";
import type { ConsentChecks, ConsentDocument, ConsentRequest } from "@fiket/booth-schema";
import type { Route } from "../../store/router";
import type { Language } from "../../i18n/locale";

/**
 * styleSelect CTA 가 갈 곳 — 동의서가 없거나 이미 동의했으면 preview, 아니면 consent.
 * consentId 는 이번 세션에서 동의서를 제출한 뒤 store 에 저장되는 ID.
 */
export function nextRouteAfterStyle(
  doc: ConsentDocument | null | undefined,
  consentId: string | null,
): Route {
  if (!doc) return "preview";
  if (consentId) return "preview";
  return "consent";
}

/** 키오스크가 서버로 보낼 ConsentRequest 를 조립한다. visitId 가 null 이면 키를 포함하지 않는다. */
export function consentPayload(
  doc: ConsentDocument,
  checks: ConsentChecks,
  language: Language,
  visitId: string | null,
): ConsentRequest {
  const base: ConsentRequest = {
    documentVersion: doc.version,
    language,
    checks,
  };
  if (visitId !== null) {
    return { ...base, visitId };
  }
  return base;
}

/** "다음" CTA 활성 여부 — 필수 항목 전부 체크 **그리고** 처리 중이 아닐 때. */
export function ctaEnabled(
  doc: ConsentDocument,
  checks: ConsentChecks,
  busy: boolean,
): boolean {
  if (busy) return false;
  return allRequiredChecked(doc, checks);
}
